module.exports = __webpack_public_path__ + "img/Google__G__Logo.f6ce5696.svg";